module.exports = __webpack_public_path__ + "img/frank.cbfee646.svg";